import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import NavigationLink from 'shared/components/NavigationLink/NavigationLink';
import s from './NavigationItem.css';

class NavigationItem extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      route: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(PropTypes.shape()),
      shouldInjectLocation: PropTypes.bool,
    }).isRequired,
    isActive: PropTypes.bool,
    eventPrefix: PropTypes.string,
  };

  static defaultProps = {
    isActive: false,
    eventPrefix: '',
  };

  render() {
    const { isActive } = this.props;
    const { items: childItems, ...item } = this.props.item;

    return (
      <div className={cx(s.root, { [s.active]: isActive })}>
        <NavigationLink className={s.link} link={item} eventPrefix={this.props.eventPrefix} />

        {childItems &&
          childItems.length > 0 &&
          <div className={s.dropdown}>
            {childItems.map(child =>
              <NavigationLink
                className={s.dLink}
                link={child}
                key={child.title}
                eventPrefix={`${this.props.eventPrefix}${item.route}`}
              />,
            )}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(NavigationItem);



// WEBPACK FOOTER //
// ./src/desktop/components/Navigation/NavigationItem/NavigationItem.js